import { FC, HTMLAttributes, Suspense } from 'react';
import { Loading } from '../../pages/site/Loading';
import { merge } from '../../utils/utility';
import { HeaderImagesPreload } from '../image/HeaderImagesPreload';
import { PageErrorBoundary } from './PageErrorBoundary';
import { SiteHeader } from './SiteHeader';

export const PageContainer: FC<HTMLAttributes<HTMLDivElement>> = ({ children, className }) => {
  return (
    <div className="w-full overflow-x-hidden">
      <div className={merge(className, 'w-screen min-h-screen bg-secondary-std')}>
        <SiteHeader />
        <Suspense fallback={<Loading></Loading>}>
          <PageErrorBoundary>
            <HeaderImagesPreload />
            {children}
          </PageErrorBoundary>
        </Suspense>
      </div>
    </div>
  );
};
